export const API_CONFIG = {
  SERVER_URL: process.env.REACT_APP_SERVER_URL || 'http://localhost:3000',
  API_PATH:   process.env.REACT_APP_API_PATH   || '/admin/api',
};

export const API_BASE_URL = `${API_CONFIG.SERVER_URL}${API_CONFIG.API_PATH}`;

export const SERVER_URL = API_CONFIG.SERVER_URL;
